import React from 'react';
import { inputBase } from './companyModalUi';

// Общие части модалок добавления/редактирования пользователя компании (REL-256).

export type AssignableRole = 'RECRUITER' | 'ADMIN' | 'OWNER';

// Роли для назначения суперадмином (по согласованию: без «Суперадмин»).
export const ROLE_OPTIONS: { value: AssignableRole; label: string }[] = [
  { value: 'RECRUITER', label: 'Рекрутер' },
  { value: 'ADMIN', label: 'Администратор' },
  { value: 'OWNER', label: 'Владелец' },
];

// Подпись роли (для отображения текущего значения, даже если оно вне ROLE_OPTIONS).
export const roleLabel = (role: string): string => {
  switch (String(role).toUpperCase()) {
    case 'SUPER_ADMIN':
      return 'Суперадминистратор';
    case 'OWNER':
      return 'Владелец';
    case 'ADMIN':
      return 'Администратор';
    case 'RECRUITER':
      return 'Рекрутер';
    default:
      return role;
  }
};

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PASSWORD_MIN = 8;

export const selectCls = `${inputBase} appearance-none cursor-pointer pl-3 pr-8 text-[16px] leading-[20px]`;
export const inputCls = `${inputBase} px-3 text-[14px] leading-[20px]`;

// Шеврон для нативных select (arrow-down-s-line по макету).
export const Chevron: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="#868C98"
    className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2"
  >
    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
  </svg>
);

/** Преобразует ошибку API создания/обновления аккаунта в сообщение для формы. */
export const accountErrorMessage = (err: any, fallback: string): string => {
  const status = err?.response?.status;
  const msg = err?.response?.data?.message;
  if (status === 409 || (typeof msg === 'string' && /email/i.test(msg) && /существ/i.test(msg))) {
    return 'Пользователь с таким email уже существует';
  }
  return msg || err?.message || fallback;
};
